<template>
<div class="chapter">
<div class="inner_page">
<h1 class="plm_hd"><a href="#/Text/Dan_contents">CHIEF ABBREVIATIONS</a></h1>
<p class="abb_fo">AB – Anchor Bible</p>
<p class="abb_fo"><em class="italic">ABD – </em>D. N. Freedman et al. (eds.), <em class="italic">The</em> <em class="italic">Anchor Bible Dictionary</em>, 6 vols. (New York: Doubleday, 1992)</p>
<p class="abb_fo">AbOTC – Abingdon Old Testament Commentary</p>
<p class="abb_fo"><em class="italic">ANET – Ancient Near Eastern Texts Relating to the Old Testament</em>, ed. James B. Pritchard, 3rd edn (Princeton: Princeton University Press, 1969)</p>
<p class="abb_fo">AOTC – Apollos Old Testament Commentary</p>
<p class="abb_fo"><em class="italic">ARAB</em> – <em class="italic">Ancient Records of Assyria and Babylonia</em>,<em class="italic"> </em>Daniel David Luckenbill, 2 vols. (Chicago: University of Chicago Press, 1926–1927, repr., New York: Greenwood, 1968)</p>
<p class="abb_fo"><em class="italic">AUSS – Andrews University Seminary Studies </em></p>
<p class="abb_fo">BDB<em class="italic"> – </em>Brown, F., S. R. Driver and C. A. Briggs, <em class="italic">A Hebrew and English Lexicon of the Old Testament </em>(Oxford: Clarendon, 1906)<em class="italic"> </em></p>
<p class="abb_fo">BLS – Bible and Literature Series</p>
<p class="abb_fo">ConC – Concordia Commentary</p>
<p class="abb_fo"><em class="italic">EANEC – Explorations in Ancient Near Eastern Civilizations </em></p>
<p class="abb_fo"><em class="italic">EBC – Expositor’s Bible Commentary </em></p>
<p class="abb_fo"><em class="italic">EvQ – Evangelical Quarterly </em></p>
<p class="abb_fo">FOTL – The Forms of the Old Testament Literature</p>
<p class="abb_fo">HDR – Harvard Dissertations in Religion</p>
<p class="abb_fo">HSM – Harvard Semitic Monographs</p>
<p class="abb_fo">IBC – Interpretation: A Bible Commentary for Teaching and Preaching</p>
<p class="abb_fo">ICC – International Critical Commentary</p>
<p class="abb_fo"><em class="italic">Int – Interpretation </em></p>
<p class="abb_fo">ITC – International Theological Commentary</p>
<p class="abb_fo"><em class="italic">JBL – Journal of Biblical Literature </em></p>
<p class="abb_fo">JSOTSup – Journal for the Study of the Old Testament Supplement Series</p>
<p class="abb_fo">LNTS – The Library of New Testament Studies</p>
<p class="abb_fo">NAC – New American Commentary</p>
<p class="abb_fo">NCBC – New Century Bible Commentary</p>
<p class="abb_fo"><em class="italic">NIDOTTE – New International Dictionary of Old Testament Theology and Exegesis</em>,<em class="italic"> </em>ed. Willem A. VanGemeren, 5 vols. (Grand Rapids: Zondervan; Carlisle: Paternoster, 1997)</p>
<p class="abb_fo">NIVAC – <span class="smallcaps">niv</span> Application Commentary</p>
<p class="abb_fo">OTL – Old Testament Library</p>
<p class="abb_fo"><em class="italic">TDOT – Theological Dictionary of the Old Testament</em>,<em class="italic"> </em>ed. G. Johannes Botterweck and Helmer Ringgren, trans. John T. Willis et al., 8 vols. (Grand Rapids: Eerdmans, 1974–2006)</p>
<p class="abb_fo"><em class="italic">Them – Themelios </em></p>
<p class="abb_fo">TOTC – Tyndale Old Testament Commentaries<em class="italic"> </em></p>
<p class="abb_fo">WBC – Word Biblical Commentary</p>
<p class="abb_fo"><em class="italic">WTJ – Westminster Theological Journal </em></p>
<h3 class="b_head" id="sigil_toc_id_1"><a href="#/Text/Dan_contents">Bible versions</a></h3>
<p class="abb_fo"><span class="smallcaps">esv</span> – English Standard Version</p>
<p class="abb_fo"><span class="smallcaps">lxx</span> – Septuagint (pre-Christian Greek version of the Old Testament)</p>
<p class="fo_rleft"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dan_Abbrev.vue?5de09b0a